"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHomecareAppointmentCancel = getHomecareAppointmentCancel;
exports.getHomecareAppointmentDetail = getHomecareAppointmentDetail;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */

function getHomecareAppointmentDetail(data, tokenData) {
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_APPOINTMENT_URL + data;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getHomecareAppointmentCancel(data, tokenData) {
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_APPOINTMENT_CANCEL_URL;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = data;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}